import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";

export const ArrowIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none" className="filter-dropdown-button__icon filter-dropdown-button__icon--arrow">
      <path d="M7.5 12L3.60288 5.25L11.3971 5.25L7.5 12Z" fill="#FF9900" />
    </svg>
  );
};

export const SortIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="filter-dropdown-button__icon filter-dropdown-button__icon--sort">
      <path d="M13.4702 7.52934C13.6108 7.66979 13.8014 7.74868 14.0002 7.74868C14.1989 7.74868 14.3895 7.66979 14.5302 7.52934L15.2502 6.80934V16.9993C15.2502 17.1983 15.3292 17.389 15.4698 17.5297C15.6105 17.6703 15.8012 17.7493 16.0002 17.7493C16.1991 17.7493 16.3898 17.6703 16.5305 17.5297C16.6711 17.389 16.7502 17.1983 16.7502 16.9993V6.80934L17.4702 7.52934C17.5388 7.60303 17.6216 7.66213 17.7136 7.70312C17.8056 7.74411 17.9049 7.76615 18.0056 7.76793C18.1063 7.76971 18.2064 7.75118 18.2998 7.71346C18.3931 7.67574 18.478 7.6196 18.5492 7.54838C18.6204 7.47716 18.6766 7.39233 18.7143 7.29894C18.752 7.20555 18.7705 7.10552 18.7687 7.00482C18.767 6.90411 18.7449 6.8048 18.7039 6.7128C18.6629 6.6208 18.6038 6.538 18.5302 6.46934L16.5302 4.46934C16.3895 4.32889 16.1989 4.25 16.0002 4.25C15.8014 4.25 15.6108 4.32889 15.4702 4.46934L13.4702 6.46934C13.3297 6.60997 13.2508 6.80059 13.2508 6.99934C13.2508 7.19809 13.3297 7.38871 13.4702 7.52934ZM8.75015 17.1893L9.47015 16.4693C9.53882 16.3957 9.62162 16.3366 9.71362 16.2956C9.80561 16.2546 9.90493 16.2325 10.0056 16.2307C10.1063 16.229 10.2064 16.2475 10.2998 16.2852C10.3931 16.3229 10.478 16.3791 10.5492 16.4503C10.6204 16.5215 10.6766 16.6064 10.7143 16.6997C10.752 16.7931 10.7705 16.8932 10.7687 16.9939C10.767 17.0946 10.7449 17.1939 10.7039 17.2859C10.6629 17.3779 10.6038 17.4607 10.5302 17.5293L8.53015 19.5293C8.38953 19.6698 8.1989 19.7487 8.00015 19.7487C7.8014 19.7487 7.61078 19.6698 7.47015 19.5293L5.47015 17.5293C5.39647 17.4607 5.33736 17.3779 5.29637 17.2859C5.25538 17.1939 5.23334 17.0946 5.23156 16.9939C5.22979 16.8932 5.24831 16.7931 5.28603 16.6997C5.32375 16.6064 5.3799 16.5215 5.45112 16.4503C5.52233 16.3791 5.60717 16.3229 5.70056 16.2852C5.79394 16.2475 5.89397 16.229 5.99468 16.2307C6.09538 16.2325 6.19469 16.2546 6.28669 16.2956C6.37869 16.3366 6.46149 16.3957 6.53015 16.4693L7.25015 17.1893V6.99934C7.25015 6.80043 7.32917 6.60966 7.46982 6.46901C7.61048 6.32836 7.80124 6.24934 8.00015 6.24934C8.19907 6.24934 8.38983 6.32836 8.53048 6.46901C8.67114 6.60966 8.75015 6.80043 8.75015 6.99934V17.1893Z" fill="#FF9900" />
    </svg>
  );
};

export const SortArrowIcon = ({ isAsc }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={`filter-dropdown-button__icon filter-dropdown-button__icon--sort-arrow ${isAsc ? 'is-asc' : ''}`}>
      <path fillRule="evenodd" clipRule="evenodd" d="M9.23871 16.22L8.51871 16.94V6.75C8.51871 6.55109 8.43969 6.36032 8.29904 6.21967C8.15839 6.07902 7.96762 6 7.76871 6C7.5698 6 7.37903 6.07902 7.23838 6.21967C7.09773 6.36032 7.01871 6.55109 7.01871 6.75V16.94L6.29871 16.22C6.23005 16.1463 6.14725 16.0872 6.05525 16.0462C5.96325 16.0052 5.86393 15.9832 5.76323 15.9814C5.66253 15.9796 5.5625 15.9982 5.46911 16.0359C5.37572 16.0736 5.29089 16.1297 5.21967 16.201C5.14845 16.2722 5.09231 16.357 5.05459 16.4504C5.01686 16.5438 4.99834 16.6438 5.00012 16.7445C5.00189 16.8452 5.02394 16.9445 5.06493 17.0365C5.10592 17.1285 5.16502 17.2113 5.23871 17.28L7.23871 19.28C7.37933 19.4205 7.56996 19.4993 7.76871 19.4993C7.96746 19.4993 8.15808 19.4205 8.29871 19.28L10.2987 17.28C10.3724 17.2113 10.4315 17.1285 10.4725 17.0365C10.5135 16.9445 10.5355 16.8452 10.5373 16.7445C10.5391 16.6438 10.5206 16.5438 10.4828 16.4504C10.4451 16.357 10.389 16.2722 10.3177 16.201C10.2465 16.1297 10.1617 16.0736 10.0683 16.0359C9.97492 15.9982 9.87489 15.9796 9.77419 15.9814C9.67348 15.9832 9.57417 16.0052 9.48217 16.0462C9.39017 16.0872 9.30737 16.1463 9.23871 16.22Z" fill="#FF7D1F" />
    </svg>
  );
};

const Dropdown = memo(({
  title,
  iconSlot,
  onClick,
  onToggle,
  children
}) => {
  const dropdownRef = useRef(null);
  const hoverTimeoutRef = useRef(null);
  const [isOpened, setIsOpened] = useState(false);

  const onButtonClick = useCallback(() => {
    if (onClick) {
      onClick();
    } else {
      setIsOpened(!isOpened);
    }
  }, [onClick, isOpened]);

  const onMouseEnter = useCallback(() => {
    if (!onClick) {
      clearTimeout(hoverTimeoutRef.current);
      setIsOpened(true);
    }
  }, []);

  const onMouseLeave = useCallback(() => {
    if (!onClick) {
      hoverTimeoutRef.current = setTimeout(() => {
        setIsOpened(false);
      }, 200);
    }
  }, []);

  useEffect(() => {
    !!onToggle && onToggle(isOpened);

    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpened(false);
      }
    };

    if (isOpened) {
      document.addEventListener('mousedown', handleOutsideClick);
      document.addEventListener('touchstart', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('touchstart', handleOutsideClick);
    }

    return () => {
      clearTimeout(hoverTimeoutRef.current);
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('touchstart', handleOutsideClick);
    };
  }, [isOpened]);

  return (
    <div
      className={`filter-dropdown ${isOpened ? 'is-opened' : ''}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      ref={dropdownRef}
      role="button"
    >
      <div className="filter-dropdown-button" onClick={onButtonClick}>
        <span className="filter-dropdown-button__title">{title}</span>
        {iconSlot}
      </div>
      {isOpened && (
        <div className="filter-dropdown-content">
          {children}
        </div>
      )}
    </div>
  );
});

export default Dropdown;